/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Resolved narrative root workstream for a planning period (pillar admin).
 */
export type NarrativeRootAdminResponse = {
    root_workstream_id: number;
    timeframe: string;
    fiscal_year: number;
    fiscal_half: NarrativeRootAdminResponse.fiscal_half;
};

export namespace NarrativeRootAdminResponse {

    export enum fiscal_half {
        H1 = 'H1',
        H2 = 'H2',
    }


}

